export const isAvailable = (data) => {
    return data?.type === 'AVAILABLE';
};
